module.exports = __webpack_public_path__ + "common/polygon-23ea93d31ee4f7221a0b638c60f7dbd8.svg";